// extracted by mini-css-extract-plugin
module.exports = {"offlineWrapper":"BuoyOfflineWrapper_offlineWrapper__jWzIe"};